<template>
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <div class="card bg-secondary shadow border-0">
        <div class="card-header bg-transparent text-center border-0">
          <h1>เข้าสู่ระบบ</h1>
        </div>
        <div class="card-body">
          <form role="form" v-on:submit="login">
            <base-input
              name="email"
              class="input-group-alternative mb-3"
              placeholder="Username"
              addon-left-icon="ni ni-single-02"
              v-model="email"
              :disabled="processing || showModal"
            ></base-input>

            <base-input
              name="password"
              class="input-group-alternative"
              placeholder="Password"
              type="password"
              addon-left-icon="ni ni-lock-circle-open"
              v-model="password"
              :disabled="processing || showModal"
            ></base-input>

            <p class="text-sm text-red">{{ msg }}</p>
            <div class="text-center">
              <!-- disable ทั้งฟอร์มขณะ modal OTP เปิดอยู่ — กันเคสที่ browser autofill
                   เปลี่ยนค่า email/password แล้ว user เผลอกด login ซ้ำ จน snapshot
                   ถูก overwrite ด้วย credential คนละชุดกับที่กำลังกรอก OTP อยู่ -->
              <input
                type="submit"
                class="mb-4 btn btn-success"
                value="เข้าสู่ระบบ"
                :disabled="processing || showModal"
              />
            </div>
          </form>
        </div>
      </div>
      <Modal :show="showModal">
        <div class="col text-center">
          <h2>
            กรุณาใส่รหัสยืนยัน
          </h2>
          <base-input
            name="otp"
            class="input-alternative"
            placeholder="รหัสยืนยัน"
            type="text"
            addon-left-icon="ni ni-lock-circle-open"
            v-model="otp"
            :disabled="processing"
          ></base-input>
          <p class="text-sm text-red">{{ msgOTP }}</p>
          <button
            type="button"
            class="close mt--5"
            data-dismiss="modal"
            aria-label="Close"
            @click="showModal = false"
          ></button>
          <div class="row justify-content-around mt-4">
            <base-button
              type="info"
              size="md"
              :disabled="processing"
              @click="loginOTP"
              >ยืนยัน</base-button
            >
            <base-button type="warning" size="md" @click="showModal = false"
              >ปิด</base-button
            >
          </div>
        </div></Modal
      >
    </div>
  </div>
</template>
<script>
import Modal from "../components/Modal";
import router from "../router";
import axios from "axios";

export default {
  name: "login",
  components: {
    Modal,
  },
  data() {
    return {
      otp: "",
      showModal: false,
      email: "",
      password: "",
      msg: "",
      msgOTP: "",
      processing: false,
      // snapshot ของ email/password ตอนยิง /api/login — ใช้ส่งซ้ำตอน /api/loginOTP
      // กันเคส browser autofill เปลี่ยนค่าใน input ระหว่างรอกรอก OTP แล้ว
      // loginOTP ส่ง credentials คนละชุดกับตอน login → backend ออก token ผิดคน
      submittedEmail: "",
      submittedPassword: "",
    };
  },
  methods: {
    login: async function(e) {
      e.preventDefault();
      this.processing = true;
      this.msg = "";
      // snapshot ไว้ก่อนยิง — loginOTP ต้องใช้ค่าชุดเดียวกันนี้
      this.submittedEmail = this.email;
      this.submittedPassword = this.password;
      const url = "/api/login";
      try {
        await axios
          .post(url, { email: this.submittedEmail, password: this.submittedPassword })
          .then((res) => {
            this.processing = false;
            if (res.data.success) {
              if (res.data.success === true) {
                this.otp = "";
                this.msgOTP = "";
                this.showModal = true;
              } else if (
                res.data.success.token &&
                res.data.name !== undefined &&
                res.data.level !== undefined
              ) {
                // ล้างข้อมูลของผู้ใช้คนก่อนออกก่อนเสมอ (เครื่องนี้อาจถูกใช้ร่วมกันหลายคน)
                localStorage.clear();
                sessionStorage.clear();
                localStorage.token = res.data.success.token;
                localStorage.level = res.data.level;
                localStorage.name = res.data.name;
                sessionStorage.identityVerified = "1";
                router.push("/customerWsu");
              } else {
                // ได้ response สำเร็จแต่ข้อมูลไม่ครบ — ถือว่าล้มเหลว ไม่เก็บค่าใดๆ
                localStorage.clear();
                sessionStorage.clear();
                this.msg = "เข้าสู่ระบบไม่สำเร็จ กรุณาลองใหม่อีกครั้ง";
              }
            } else {
              this.processing = false;
              this.msg = "ชื่อผู้ใช้งานหรือรหัสผ่านไม่ถูกต้อง";
            }
          });
      } catch (err) {
        this.processing = false;
        this.msg = "ชื่อผู้ใช้งานหรือรหัสผ่านไม่ถูกต้อง";
      }
    },
    loginOTP: async function(e) {
      e.preventDefault();
      this.processing = true;
      this.msgOTP = "";
      const url = "/api/loginOTP";
      try {
        await axios
          .post(url, {
            // ใช้ snapshot จากตอน login — ไม่อ่าน this.email/this.password ใหม่
            // เพราะ browser autofill อาจเปลี่ยนค่าใน input ระหว่างรอกรอก OTP
            email: this.submittedEmail,
            password: this.submittedPassword,
            totp: this.otp,
          })
          .then((res) => {
            this.processing = false;
            if (
              res.data.success &&
              res.data.success.token &&
              res.data.name !== undefined &&
              res.data.level !== undefined
            ) {
              // ล้างข้อมูลของผู้ใช้คนก่อนออกก่อนเสมอ (เครื่องนี้อาจถูกใช้ร่วมกันหลายคน)
              localStorage.clear();
              sessionStorage.clear();
              localStorage.token = res.data.success.token;
              localStorage.level = res.data.level;
              localStorage.name = res.data.name;
              sessionStorage.identityVerified = "1";
              router.push("/dashboard");
            } else {
              // ล้มเหลว หรือ response ไม่ครบ — ไม่เก็บค่าใดๆ
              localStorage.clear();
              sessionStorage.clear();
              this.msgOTP = "รหัสยืนยันไม่ถูกต้องหรือไม่ได้ทำรายการนานเกินไป";
            }
          });
      } catch (err) {
        this.processing = false;
        this.msgOTP = "รหัสยืนยันไม่ถูกต้องหรือไม่ได้ทำรายการนานเกินไป";
      }
    },
  },
  created: async function() {
    // ตรวจ token ที่ค้างใน localStorage กับ backend ก่อนข้ามไปหน้าใช้งาน
    // ป้องกันเคส: เครื่องที่ใช้ร่วมกัน user คนก่อนปิด browser โดยไม่ logout
    // → token ของคนก่อนค้างอยู่ → ถ้า redirect ทันทีจะกลายเป็น login ค้าง
    if (!localStorage.token) return;
    try {
      const res = await axios.get("/api/me", {
        headers: {
          Authorization: "Bearer " + localStorage.token,
          "Cache-Control": "no-store",
          Pragma: "no-cache",
        },
      });
      // ยืนยันว่า token ยังใช้ได้ และข้อมูลใน localStorage ตรงกับ user จริง
      if (
        res.data &&
        res.data.name !== undefined &&
        res.data.level !== undefined &&
        String(res.data.name) === String(localStorage.name) &&
        String(res.data.level) === String(localStorage.level)
      ) {
        sessionStorage.identityVerified = "1";
        router.replace("/customerWsu");
      } else {
        // token ใช้ไม่ได้ หรือ name/level ใน localStorage ไม่ตรงกับ user จริง
        // → ล้างของเก่าทิ้ง แล้วให้ login ใหม่
        localStorage.clear();
        sessionStorage.clear();
      }
    } catch (err) {
      // 401 หรือ network error — ถือว่า token ใช้ไม่ได้
      localStorage.clear();
      sessionStorage.clear();
    }
  },
};
</script>
<style>
/* html {
  height: 100%;
  width: 100%;
} */
body,
#app {
  height: 100%;
  margin: 0;
  padding: 0;
  background-color: #ffffff;
}
</style>
